import {IAbstractModule, IModuleType} from "@/model/Locker/IModule";

export const ModuleZ3compB: IAbstractModule = {
    type: IModuleType.Z3comp,
    name: 'Z 3 compartment B',
    hasScreen: false,
    columns: [
        [
            {
                name: "1",
                connector: "1",
                cell_size_id: 5,
                accessible: false,
            },
            {
                name: "2",
                connector: "2",
                cell_size_id: 5,
                accessible: false,
            },
            {
                name: "3",
                connector: "3",
                cell_size_id: 1,
                accessible: false,
            },
        ],
    ]
};
